export default "__VITE_ASSET__Coc4nwTf__"